import { Directive, Input } from '@angular/core';

interface AutocompleteOptionTemplateContext<T extends object | string> {
  $implicit: T;
}

@Directive({
  selector: 'ng-template[pluginsAutocompleteOption]',
  standalone: true,
})
export class AutocompleteOptionDirective<T extends object | string> {
  @Input('pluginsAutocompleteOption') options!: T[];

  static ngTemplateContextGuard<U extends object | string>(
    dir: AutocompleteOptionDirective<U>,
    ctx: unknown,
  ): ctx is AutocompleteOptionTemplateContext<U> {
    return true;
  }
}
